import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María G.', 'Carlos R.', 'Ana L.', 'Pedro M.', 'Laura S.', 'José H.', 'Carmen V.', 'Miguel A.', 'Isabel F.', 'David T.', 'Sofía N.', 'Roberto C.', 'Elena P.', 'Francisco J.', 'Patricia B.'];
const locations = ['Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena', 'Bucaramanga', 'Pereira', 'Manizales', 'Santa Marta', 'Ibagué', 'Villavicencio', 'Pasto', 'Neiva', 'Armenia', 'Montería', 'Popayán', 'Tunja', 'Cúcuta', 'Valledupar', 'Sincelejo', 'Palmira', 'Bello', 'Soledad', 'Soacha', 'Itagüí'];
const prices = ['$19.999 COP'];
const paymentMethods = [{
  label: 'Nequi',
  emoji: '💜',
  color: 'text-purple-600'
}, {
  label: 'Bancolombia',
  emoji: '🟡',
  color: 'text-yellow-600'
}, {
  label: 'PSE',
  emoji: '🏦',
  color: 'text-blue-600'
}, {
  label: 'Tarjeta de crédito',
  emoji: '💳',
  color: 'text-gray-600'
}, {
  label: 'Nequi',
  emoji: '💜',
  color: 'text-purple-600'
}, {
  label: 'Nequi',
  emoji: '💜',
  color: 'text-purple-600'
}, {
  label: 'Bancolombia',
  emoji: '🟡',
  color: 'text-yellow-600'
}, {
  label: 'Daviplata',
  emoji: '🔴',
  color: 'text-red-600'
}, {
  label: 'PSE',
  emoji: '🏦',
  color: 'text-blue-600'
}];
interface Notification {
  id: number;
  name: string;
  location: string;
  timeAgo: string;
  price: string;
  paymentMethod: {
    label: string;
    emoji: string;
    color: string;
  };
}
interface PurchaseNotifierProps {
  enabled?: boolean;
  displayPrice?: string;
}
export const PurchaseNotifier = ({
  enabled = true,
  displayPrice
}: PurchaseNotifierProps) => {
  const [notification, setNotification] = useState<Notification | null>(null);
  useEffect(() => {
    if (!enabled) return;
    const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
    const getTimeAgo = () => {
      const minutes = Math.floor(Math.random() * 30) + 1;
      if (minutes === 1) return 'hace 1 minuto';
      return `hace ${minutes} minutos`;
    };
    const showNotification = () => {
      const newNotification: Notification = {
        id: Date.now(),
        name: getRandomItem(names),
        location: getRandomItem(locations),
        timeAgo: getTimeAgo(),
        price: displayPrice || getRandomItem(prices),
        paymentMethod: getRandomItem(paymentMethods)
      };
      setNotification(newNotification);
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    };
    // First notification after 5 seconds
    const initialTimeout = setTimeout(showNotification, 5000);
    // Subsequent notifications every 30 seconds
    const interval = setInterval(showNotification, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [enabled]);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-1288">
      <AnimatePresence mode="wait" data-id="element-1289">
        {notification && <motion.div key={notification.id} initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white rounded-lg shadow-lg border border-gray-100 p-2 flex items-center gap-2 max-w-[220px] pointer-events-auto" data-id="element-1290">
            <div className="bg-green-500 rounded-full p-1.5 flex-shrink-0" data-id="element-1291">
              <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1292">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" data-id="element-1293" />
              </svg>
            </div>
            <div className="flex-1 min-w-0" data-id="element-1294">
              <p className="text-[10px] font-bold text-gray-900 leading-tight" data-id="element-1295">
                {notification.name}{' '}
                <span className="font-normal text-gray-500" data-id="element-1296">
                  de {notification.location}
                </span>
              </p>
              <p className="text-[10px] text-gray-700 font-medium leading-tight" data-id="element-1297">
                acaba de comprar 🐾{' '}
                <span className="font-bold text-green-600" data-id="element-1298">
                  {notification.price}
                </span>
              </p>
              <p className={`text-[10px] font-medium leading-tight ${notification.paymentMethod.color}`} data-id="element-1299">
                {notification.paymentMethod.emoji}{' '}
                {notification.paymentMethod.label}
              </p>
              <p className="text-[10px] text-gray-400 leading-tight" data-id="element-1300">
                {notification.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};